const initialState = {
  generalEvaluation: {},
  saving: false,
  fetching: false,
  fetchError: null,
  evaluation: { data: {}, loading: false, error: null,},
  assessments: { saving: false, deleting: false, error: null,},
  attributes: { saving: false, deleting: false, error: null,},
  reviews: {
    data: [], 
    saving: false,
    loading: false,
    success: false,
    error: null,
  }
};

const evaluationReducer = (state = initialState, action) => {
  switch (action.type) {
    // Evaluación General
    case "FETCH_GENERAL_EVALUATION_REQUEST":
      return { ...state, fetching: true, fetchError: null };
    case "FETCH_GENERAL_EVALUATION_SUCCESS":
      return { ...state, generalEvaluation: action.payload, fetching: false, fetchError: null };
    case "FETCH_GENERAL_EVALUATION_FAIL":
      return { ...state, generalEvaluation: {}, fetching: false, fetchError: action.payload };

    // Evaluación General
    case "SAVE_GENERAL_EVALUATION_REQUEST":
      return { ...state, saving: true };
    case "SAVE_GENERAL_EVALUATION_SUCCESS":
    case "SAVE_GENERAL_EVALUATION_FAIL":
      return { ...state, saving: false };

    // Evaluación
    case "GET_EVALUATION_REQUEST":
      return {...state, evaluation: { loading: true, error: null },};
    case "GET_EVALUATION_SUCCESS":
      return {...state, evaluation: { data: action.payload, loading: false, error: null },};
    case "GET_EVALUATION_FAIL":
      return {...state, evaluation: { data: {}, loading: false, error: action.payload },};

    // Guardar valoración
    case "SAVE_VALORACION_REQUEST":
      return {...state, assessments: {...state.assessments, saving: true, error: null },};
    case "SAVE_VALORACION_SUCCESS":
      return {...state, assessments: {...state.assessments, saving: false, error: null },};
    case "SAVE_VALORACION_FAIL":
      return {...state, assessments: {...state.assessments, saving: false, error: action.payload },};
    
      // borrar valoración 
    case "DELETE_VALORACION_REQUEST":
      return {...state, assessments: { ...state.assessments, deleting: true, error: null },};
    case "DELETE_VALORACION_SUCCESS":
      return {...state, assessments: { ...state.assessments, deleting: false, error: null },};
    case "DELETE_VALORACION_FAIL":
      return {...state, assessments: { ...state.assessments, deleting: false, error: action.payload },};

    // Guardar atributo
    case "SAVE_CUALIDAD_REQUEST":
      return {...state, attributes: { ...state.attributes, saving: true, error: null },};
    case "SAVE_CUALIDAD_SUCCESS":
      return {...state, attributes: { ...state.attributes, saving: false, error: null },};
    case "SAVE_CUALIDAD_FAIL":
      return {...state, attributes: { ...state.attributes, saving: false, error: action.payload },};

    // Eliminar atributo
    case "DELETE_CUALIDAD_REQUEST":
      return {...state, attributes: { ...state.attributes, deleting: true, error: null },};
    case "DELETE_CUALIDAD_SUCCESS":
      return {...state, attributes: { ...state.attributes, deleting: false, error: null },};
    case "DELETE_CUALIDAD_FAIL":
      return {...state, attributes: { ...state.attributes, deleting: false, error: action.payload },};

    // Gestion de Revisiones
    case "SAVE_REVISION_REQUEST":
      return {
        ...state,
        reviews: { ...state.reviews, saving: true, error: null },
      };
    case "SAVE_REVISION_SUCCESS":
      return {
        ...state,
        reviews: { ...state.reviews, saving: false, error: null },
      };
    case "SAVE_REVISION_FAIL":
      return {
        ...state,
        reviews: { ...state.reviews, saving: false, error: action.payload },
      };
    case "DELETE_REVISION_REQUEST":
      return {
        ...state,
        reviews: { ...state.reviews, loading: true, error: null },
      };
    case "DELETE_REVISION_SUCCESS":
      return {
        ...state,
        reviews: { ...state.reviews, loading: false, error: null },
      };
    case "DELETE_REVISION_FAIL":
      return {
        ...state,
        reviews: { ...state.reviews, loading: false, error: action.payload },
      };
      
    case 'PROCESS_CHANGED_CLEAR_STATE':
    case 'PERMISSION_CHANGED_CLEAR_STATE':
      return { ...initialState };

    default:
      return state;
  }
};

export default evaluationReducer;
